import { Card, Badge, Button } from '../../components/ui';
import './Notificaciones.css';

const BORDE = { info: 'var(--c-primary)', warning: 'var(--c-warning)', neutral: 'var(--c-border)' };

export default function TarjetaNotificacion({ noti }) {
  return (
    <Card style={{ borderLeft: `4px solid ${BORDE[noti.tono]}` }}>
      <div className="notificaciones-row">
        <div className="notificaciones-body">
          <div className="notificaciones-title-row">
            {!noti.leida && <Badge tone={noti.tono === 'neutral' ? 'info' : noti.tono}>Nueva</Badge>}
            <strong>{noti.titulo}</strong>
          </div>
          <p className="notificaciones-muted" style={{ margin: '4px 0 0' }}>{noti.texto}</p>
          <span className="notificaciones-hint">{noti.cuando}{noti.leida ? ' · leída' : ''}</span>
        </div>
        {!noti.leida && <Button variant="ghost" size="sm">Marcar leída</Button>}
      </div>
    </Card>
  );
}